import { useEffect, useRef } from 'react';
import { Html5QrcodeScanner } from 'html5-qrcode';

interface QRCodeScannerProps {
  onDetected: (decodedText: string) => void;
  onClose: () => void;
}

const QRCodeScanner = ({ onDetected, onClose }: QRCodeScannerProps) => {
  const scannerRef = useRef<Html5QrcodeScanner | null>(null);

  useEffect(() => {
    const qrScanner = new Html5QrcodeScanner(
      'qr-reader',
      {
        fps: 10,
        qrbox: { width: 250, height: 250 },
      },
      false
    );

    const onScanSuccess = (decodedText: string) => {
      onDetected(decodedText);
      qrScanner.clear().catch(() => {});
    };

    const onScanError = () => {
      // ignore scan errors
    };

    try {
      qrScanner.render(onScanSuccess, onScanError);
      scannerRef.current = qrScanner;
    } catch {
      // camera unavailable
    }

    return () => {
      scannerRef.current?.clear().catch(() => {});
      scannerRef.current = null;
    };
  }, [onDetected]);

  const handleClose = () => {
    scannerRef.current?.clear().catch(() => {});
    onClose();
  };

  return (
    <div className="qr-scanner">
      <div id="qr-reader"></div>
      <button className="btn btn-secondary" onClick={handleClose}>
        Close Scanner
      </button>
    </div>
  );
};

export default QRCodeScanner;
